import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { GarantiasResInterface } from 'src/app/core/interfaces/garantias-res.interface';

@Injectable({
  providedIn: 'root'
})
export class GarantiasOpcionalesService {

  /**
   * @description Constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description Recuperar garantias opcionales
   * @params idProducto
   */
  getGaranteeOptional(idProducto: number): Observable<object> {
    const headerConfig: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
    };
    const obj: any = { idProducto };
    headerConfig.params = new HttpParams({ fromObject: obj });


    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.garantiasOpcionales.name,
      headerConfig
    ).pipe(
      map((response: any) => {
        return response.map((element: any) => ( {
          IdGarantia: element.idGarantia,
          IdProducto: element.idProducto,
          ImpLimite : element.impLimite,
          ImpLimiteMaximo: element.impLimiteMaximo,
          ImpTramoLimite: element.impTramoLimite,
          IndLimiteOpcional: element.indLimiteOpcional,
          IndOpcional: element.indOpcional,
          Literal: element.literal,
          Num_opcion_Contratacion: element.numOpcionContratacion,
          DescripcionWeb: element.descripcionWeb
        }));
      })

      );
  }
}
